import { Tabs as TabsPrimitive } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const TabsContent = React.forwardRef(({ className, ...props }, ref) => {
    return (React.createElement(TabsPrimitive.Panel, { ref: ref, className: cn("in-tabs__content", className), ...props }));
});
TabsContent.displayName = "TabsContent";
export { TabsContent };
//# sourceMappingURL=tabsContent.js.map